// One-line plain-English comparison of a report-card year against the previous one.
const METRICS = [
  { key: "active_days", up: (a, b, y) => `Active days up ${pct(a, b)} on ${y} (${a} -> ${b}) - the weekly habit is sticking.`, down: (a, b, y) => `Fewer active days than ${y} (${a} -> ${b}) - a lesson-day reminder can bring the rhythm back.` },
  { key: "certificates_year", up: (a, b, y) => `${b} certificate${b === 1 ? "" : "s"} vs ${a} in ${y} - more lessons finished start to end.`, down: (a, b, y) => `${b} certificate${b === 1 ? "" : "s"} vs ${a} in ${y} - there are lessons left to finish this year.` },
  { key: "longest_streak_weeks", up: (a, b, y) => `Longest streak grew from ${a} to ${b} weeks - consistency is the real win.`, down: (a, b, y) => `Longest streak was ${b} weeks (${a} in ${y}) - one step a week keeps it alive.` },
  { key: "bamboo_year", up: (a, b, y) => `Bamboo up ${pct(a, b)} on ${y} - lots more lesson steps completed.`, down: (a, b, y) => `Less bamboo than ${y} (${a} -> ${b}) - fewer steps completed this year.` },
  { key: "cheers_year", up: (a, b, y) => `Cheers up from ${a} to ${b} - the fan club is growing.`, down: (a, b, y) => `Fewer cheers than ${y} (${a} -> ${b}) - a nudge to grandparents goes a long way.` },
];

const pct = (a, b) => (a > 0 ? `${Math.round(((b - a) / a) * 100)}%` : `${b}`);
const quiet = (c) => METRICS.every((m) => !(c[m.key] > 0));

export const yearInsight = (prev, now) => {
  if (!prev) return null;
  if (quiet(prev) && quiet(now)) return `Nothing logged in ${prev.year} or ${now.year} yet - the first step starts the story.`;
  if (quiet(prev)) return `${now.year} is the first year with lessons on record - every step from here is growth.`;
  const scored = METRICS.map((m) => {
    const a = prev[m.key] || 0, b = now[m.key] || 0;
    return { m, a, b, score: a > 0 ? (b - a) / a : b > 0 ? 1 : 0 };
  });
  const best = [...scored].sort((x, y) => y.score - x.score)[0];
  if (best.score > 0) return best.m.up(best.a, best.b, prev.year);
  const worst = [...scored].sort((x, y) => x.score - y.score)[0];
  if (worst.score < 0) return worst.m.down(worst.a, worst.b, prev.year);
  return `Steady as ${prev.year} - same pace, same habits.`;
};
